import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { SupplierWriteRequest } from '@/api/handlers/resources/suppliers/requests';
import type { SupplierWriteResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

export type UpdateSupplierVariables = {
    id: string;
    body: SupplierWriteRequest;
};

export const useUpdateSupplierMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<SupplierWriteResponse>,
        Error,
        UpdateSupplierVariables
    >({
        mutationFn: ({ id, body }) =>
            apiClient.suppliers.updateSupplier(id, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: SupplierQueryKeys.all,
                });
            }
        },
    });
};
